import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { SHARED_TOKEN_PREFIX } from '~/screens/SharedSavedList';

import { useGetSavedListCreators } from './useGetSavedListCreators';
import { useGetSharedSavedListCreators } from './useGetSharedSavedListCreators';

export const useGetSavedListCreatorsAll = ({
  id,
  enabled = true,
}: {
  id: string;
  enabled?: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();
  const isShared = router.pathname.includes('/shared/');
  const sharedToken = `${SHARED_TOKEN_PREFIX}${router.query.id}` as string;

  const creatorsLoggedIn = useGetSavedListCreators({ id, enabled: false });
  const creatorsShared = useGetSharedSavedListCreators({
    id,
    sharedToken,
  });

  const creators = isShared ? creatorsShared : creatorsLoggedIn;

  useEffect(() => {
    // Iteratively load next page(s)
    if (creators.error) return;
    if (creators.hasNextPage === false || !id || !enabled) {
      setIsLoading(false);
      return;
    }

    // Has next page
    creators.fetchNextPage();
  }, [creators, id, enabled]);

  // @ts-ignore - types f'ed up
  return { isLoading, creators: creators.data?.creators || [] };
};
